import { SettlementRepositoryImpl } from '../Data/SettlementRepositoryImpl';
import { SearchSettlementsUseCase } from '../Domain/usecases/SearchSettlementsUseCase';
import { GetCommissionSumUseCase } from '../Domain/usecases/GetCommissionSumUseCase';
import { SearchCommissionsUseCase } from '../Domain/usecases/SearchCommissionsUseCase';
import { SearchTransactionsUseCase } from '../Domain/usecases/SearchTransactionsUseCase';
import { SearchProjectMonthlySumUseCase } from '../Domain/usecases/SearchProjectMonthlySumUseCase';

const repository = new SettlementRepositoryImpl();

export const settlementUseCases = {
  searchSettlements: new SearchSettlementsUseCase(repository),
  getCommissionSum: new GetCommissionSumUseCase(repository),
  searchCommissions: new SearchCommissionsUseCase(repository),
  searchTransactions: new SearchTransactionsUseCase(repository),
  searchProjectMonthlySum: new SearchProjectMonthlySumUseCase(repository),
};

